import { find, groupBy, map } from 'lodash';

const FUEL_PAIRS = {
  electric_diesel: 'hybrid_diesel',
  electric_gasoline: 'hybrid_gasoline'
};

export const groupFuels = (items) => {
  const itemsWithPairText = map(items, (item) => {
    const pair = FUEL_PAIRS[item.key] && find(items, { key: FUEL_PAIRS[item.key] });
    return pair ? { ...item, text: pair.text } : item;
  });

  return map(groupBy(itemsWithPairText, 'text'), (fuels, text) => ({ key: map(fuels, 'key').join(','), text }));
};
